$(document).ready(function () {

    var inputs = $('.inputfile');
    inputs.each(function () {
        var input = $(this);
        var label = input.next(),
            labelVal = label.html();

        input.on('change', function (e) {
            var fileName = '';
            if (this.files && this.files.length > 1) {
                fileName = (input.data('multiple-caption') || '').replace('{count}', this.files.length);
            } else {
                fileName = e.target.value.split('\\').pop();
            }
            console.log('drytfuygiuhijokp', fileName);

            if (fileName) {
                label.children('span').html(fileName);
            } else {
                label.html(labelVal);
            }
        });
    });


    $('.submit-devis').on('click', function () {

        // Limite de taille du fichier en octets (par exemple, 2 Mo)
        const maxFileSize = 20 * 1024 * 1024; // 20 Mo en octets
        const fileInput = $('#docpicker')[0];
        const file = fileInput.files[0];

        // Vérifier la taille du fichier
        if (file && file.size > maxFileSize) {
            alert('Le fichier dépasse la taille maximale de 20 Mo.');
            return; // Empêcher l'envoi du formulaire si la taille du fichier dépasse la limite
        }

        let formData = new FormData();
        formData.append("product_link", $('.info').data('product_link'));
        formData.append("product_name", $('.name_of_product').html());
        formData.append("product_ref", $('.ref_of_product').html());
        formData.append("client_id", $(this).data('user_id'));
        formData.append("email", $('.email_to_send').html());
        formData.append("phone", $('.phone_to_send').html());
        formData.append("name", $('.name_to_send').html());
        formData.append("com", $('.com').val());
        
        // Ajouter le fichier uniquement si sélectionné
        if (file) {
            formData.append("file", file);
        }

        $.ajax({
            url: mm_apiurl.devis,
            type: "post",
            data: formData,
            contentType: false,
            processData: false,
            async: false,
            dataType: "json",
            success: function (d) {
                $('.msg-text').addClass('active');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error('Erreur lors de l\'envoi des données :', textStatus, errorThrown);
            }
        });
    });
});